'use strict';

angular.module('portal.linkpage')
    .controller('LinkPage', ['$scope', '$state', '$stateParams', 'EnterpriseLinkService', '$sce', function ($scope, $state, $stateParams, EnterpriseLinkService, $sce) {
        EnterpriseLinkService.getLink($stateParams.id).then(function (link) {
            if ((link !== undefined || link != null) && typeof (link.page_content) == "string") {
                link.page_content = $sce.trustAsHtml(link.page_content);
            }
            $scope.link = link;
        });
    }]);